import { DeviceMeta } from 'Roblox';

export default {
  seeAllLinkLabel: 'ActionSeeAll',
  leftScroller: 'scroller prev',
  rightScroller: 'scroller next',
  leftScrollIcon: 'icon-games-carousel-left',
  rightScrollIcon: 'icon-games-carousel-right',
  carouselScrollStartPoint: {
    left: '0px'
  },
  currentPageLayout: {
    numberOfGamesFetched: 0,
    numberOfGamesScrolled: 0,
    isGridLayoutDisabled: false
  },
  seeAllClass: 'see-all-button games-filter-changer btn-secondary-xs btn-more see-all-link-icon',
  pageType: {
    gameCarousel: 'Games',
    gameSearch: 'GameSearch',
    gameSeeAll: 'GamesSeeAll'
  },
  numberOfGameRendering: 70,
  thresholdOfMaxNumOfGamesForSort: 60,
  sortStyle: {
    featureGameTile: 'featured-tile'
  },
  isDesktop: DeviceMeta && DeviceMeta().isDesktop,
  maxRowsLargeTiles: 16,
  maxRows: 32
};
